import React from 'react';


export default function  DeleteButton(props) {
    return (
        <a href={void(0)} className="del_pro_img" onClick={() => props.removeImage(props.index) } >
            <img src="/assets/images/del_pro_img.png" />
        </a>
    )
}